import React, { useState } from "react";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { db } from "../Firebase/Firebase";
import "./NewsletterFooter.css";

const NEWSLETTER_COLLECTION = "newsletter_subscribers";

function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

function NewsletterFooter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus(null);

    const normalized = email.trim().toLowerCase();
    if (!isValidEmail(normalized)) {
      setStatus({ type: "danger", message: "Please enter a valid email address." });
      return;
    }

    setSubmitting(true);
    try {
      await setDoc(doc(db, NEWSLETTER_COLLECTION, normalized), {
        email: normalized,
        subscribedAt: serverTimestamp(),
        source: "footer",
      });
      setStatus({ type: "success", message: "Thanks — you're on the list!" });
      setEmail("");
    } catch (err) {
      console.error("Newsletter signup failed:", err);
      setStatus({
        type: "danger",
        message: "Could not save your email. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <footer id="newsletter-signup" className="newsletter-footer">
      <Container>
        <div className="newsletter-footer-inner">
          <div className="newsletter-footer-copy">
            <h2 className="newsletter-footer-title">daily news and puzzles</h2>
            <p className="newsletter-footer-caption">
              Recieve daily news snippets and word associated games.
            </p>
          </div>
          <Form className="newsletter-footer-form" onSubmit={handleSubmit}>
            <Form.Group controlId="newsletter-email" className="newsletter-footer-field">
              <Form.Label className="visually-hidden">Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                disabled={submitting}
                required
                autoComplete="email"
              />
            </Form.Group>
            <Button type="submit" variant="dark" disabled={submitting}>
              {submitting ? "Joining…" : "Subscribe"}
            </Button>
          </Form>
          {status ? (
            <Alert variant={status.type} className="newsletter-footer-alert mb-0">
              {status.message}
            </Alert>
          ) : null}
        </div>
      </Container>
    </footer>
  );
}

export default NewsletterFooter;
